export class Profile {
    codAgente: number;
    descricao: string;
    id: number;
    nome: string;
    pathAvatar: string;

    constructor() {
        this.codAgente = null;
        this.descricao = null;
        this.id = null;
        this.nome = null;
        this.pathAvatar = null;
    }
}